exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-group-item .icon{\r\n    margin-right: unset;\r\n}\r\n\r\n.media a {\r\n    color: #818c94;\r\n}\r\n\r\n.media-image {\r\n    width: 80px;\r\n}\r\n\r\n.avatar img {\r\n    display: inline;\r\n    width: 40px;\r\n    height: 40px;\r\n    max-width: 100%;\r\n    max-height: 100%;\r\n    object-fit: cover;\r\n    border-radius: 50%;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/src/app/pages/admin/icontact/setting/queue/queue.css
// module id = ../../../../../src/app/pages/admin/icontact/setting/queue/queue.css
// module chunks = main